// Pure helpers for milestone confetti. A milestone is celebrated once, so a
// reload of a page whose trigger lives in the URL, or in an already-live
// record, does not repeat the burst.

export const CELEBRATION_HISTORY_LIMIT = 40

export function parseCelebratedKeys(raw) {
  try {
    const parsed = JSON.parse(raw)
    return Array.isArray(parsed) ? parsed.filter((key) => typeof key === "string") : []
  } catch (_error) {
    return []
  }
}

export function hasCelebrated(seenKeys, key) {
  if (typeof key !== "string" || key.length === 0) return false
  return seenKeys.includes(key)
}

export function recordCelebration(seenKeys, key, limit = CELEBRATION_HISTORY_LIMIT) {
  if (typeof key !== "string" || key.length === 0) return seenKeys
  if (seenKeys.includes(key)) return seenKeys
  return seenKeys.concat(key).slice(-limit)
}
